export default function getCustomerName(customer, isBusinessCustomer = false) {
  if (!customer) return '';
  return isBusinessCustomer ? customer?.organizationName : `${customer?.personFirstName} ${customer?.personLastName}`;
}